import React from 'react'
import { TabView, TabPanel } from 'primereact/tabview';
import CNIC from './CNIC'
import TemplateDemo from './DrivingLicense'
import VehicleDetails from '../vehicle/VehicleDetails';
import "../documents/document.css"
const Documents = () => {
    return (
        <section>
            <div className="">
                <TabView className='p-3 border-200 border-3 border-round'>
                    <TabPanel header="CNIC ">
                        <CNIC/>
                    </TabPanel>
                    <TabPanel header="Driving License">
                        <TemplateDemo />
                    </TabPanel>
                    <TabPanel header="Vehicle">
                        <VehicleDetails />
                    </TabPanel>
                </TabView>
            </div>

        </section>
    )
}

export default Documents